import { createFileRoute } from '@tanstack/react-router'
import { ProgressPage } from '../components/pages'
import { CatalogProvider } from '../content/catalog-context'
import { loadPageData } from '../content/page-data-fn'
import { noIndexRouteHead } from '../lib/seo'

export const Route = createFileRoute('/it/progressi')({
  loader: () => loadPageData({ data: { kind: 'progress', locale: 'it' } }),
  head: () => noIndexRouteHead('progress', 'it'),
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <CatalogProvider snapshot={Route.useLoaderData().snapshot}>
      <ProgressPage />
    </CatalogProvider>
  )
}
